export default {
      id: "icon_api-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#icon_api",
      toString: function () {
        return this.url;
      }
    }